import _, { filter } from 'lodash'
import BUSINESS_DIODES_CONFIG from './config'
import API_CONFIG from '../../core/api/config'
import axios from 'axios'

class BusinessDiodesClass {
    constructor() {
        this.DOM = {
            section: BUSINESS_DIODES_CONFIG.section,
            table: BUSINESS_DIODES_CONFIG.table,
            search: BUSINESS_DIODES_CONFIG.search,
            //select: BUSINESS_DIODES_CONFIG.select,
            loader: BUSINESS_DIODES_CONFIG.loader
        }

        this.endpoint = BUSINESS_DIODES_CONFIG.endpoint
        this.dttbl = null
        this.filters = []
        this.results = []
        this.data = []
        this.resultsInitial = []
        this.tableType = null
        this.tableTypeObj = null
        this.tableSearch = null

        this.selected = null
        this.selectedValue = null

        this.DOM.section ? this.init() : null

    }

    init() {
        this._isTableSearch()
        this._getTableType()
        this._data()
    }

    _isTableSearch() {
        this.tableSearch = this.DOM.table.getAttribute( 'data-search-query' )
    }

    _getTableType() {
        this.tableType = this.DOM.table.getAttribute( 'data-type' )
        this.tableTypeObj = JSON.parse( this.tableType )
    }

    _dataInitFilter() {
        this.resultsInitial = this.data

        if (this.tableSearch.length > 0) {
            if (this.selected == null) {
                this.tableTypeObj['Part number'] = this.tableSearch
            }  else if (this.selected == 'Part number') {
                if (this.selectedValue == '') {
                    this.tableTypeObj['Part number'] = this.tableSearch
                } else {
                    this.tableTypeObj['Part number'] = this.selectedValue
                }
            } else {
                this.tableTypeObj['Part number'] = this.tableSearch
                if (this.selectedValue != '') {
                    this.tableTypeObj[this.selected] = this.selectedValue
                }
            }

            console.log(this.tableTypeObj)
            
            for (const property in this.tableTypeObj) {
                if(property == 'Part number') {
                    this.resultsInitial = this.resultsInitial.filter( element => element['Part number'].toUpperCase().includes(this.tableTypeObj['Part number']))
                } else {
                    this.resultsInitial = this.resultsInitial.filter( element => element[property] === this.tableTypeObj[property] )
                }
            }
            
        } else {
            for (const property in this.tableTypeObj) {
                this.resultsInitial = this.resultsInitial.filter( element => element[property].toString() === this.tableTypeObj[property].toString() )
            }
        }

        console.log(this.tableTypeObj)


        
        this.results = this.resultsInitial
        console.log(this.results)
    }

    _data() {
        axios.get( this.DOM.table.getAttribute( 'data-json' ))
            .then( ( response ) => {
                this.data = response.data
                this._dataInitFilter()
                this._datatable()
            })
            .catch( ( error ) => {
            })
    }

    _filters() {
        this.filters = [
            { key: 'Product', value: '' },
            { key: 'Product line', value: '' },
            { key: 'Type', value: '' },
            { key: 'Family', value: '' },
            { key: 'Part number', value: '' },
            { key: 'IF(AV) (A)', value: '' },
            { key: 'VRRM (V)', value: '' },
            { key: 'TRR (ns)', value: '' },
            { key: 'VF (V)', value: '' },
            { key: 'PZ (W)', value: '' },
            { key: 'PPP (W)', value: '' },
            { key: 'VZ (V)', value: '' },
            { key: 'VCL (V)', value: '' },
            { key: 'IPP (A)', value: '' },
            { key: 'Direc', value: '' },
            { key: 'IFSM (A)', value: '' },
            { key: 'Outline', value: '' }
        ]
    }

    _listeners( api ) {
        //this.DOM.search.addEventListener( 'keyup', this._search.bind( this, api ) )
        this.DOM.select.addEventListener( 'change', this._search.bind( this, api ) )
    }

    _datatable() {
        
        let THIS = this
        this.dttbl = $(this.DOM.table).DataTable({
            dom: '<"top"f>t<"bottom"p>',
            pagingType: 'numbers',
            ordering: false,
            language: {
                emptyTable: this.DOM.table.getAttribute( 'data-l-noresults' ),
                loadingRecords: this.DOM.table.getAttribute( 'data-l-loading' ),
                zeroRecords: this.DOM.table.getAttribute( 'data-l-nomatching' )
            },
            data: this.results,
            dataSrc: '',
            columns: [
                { data: 'Product' },
                { data: 'Product line' },
                { data: 'Type' },
                { data: 'Part number' },
                { data: 'Family' },
                { data: 'IF(AV) (A)' },
                { data: 'VRRM (V)' },
                { data: 'TRR (ns)' },
                { data: 'VF (V)' },
                { data: 'PZ (W)' },
                { data: 'PPP (W)' },
                { data: 'VZ (V)' },
                { data: 'VCL (V)' },
                { data: 'IPP (A)' },
                { data: 'Direc' },
                { data: 'IFSM (A)' },
                { data: 'Outline' }
            ],  
            
            columnDefs: [
                { targets: [0, 1, 2], visible: false},
                {
                    "targets": '_all',
                    "render": function ( data, type, row, meta ) {
                        if (meta.col == 3 ) {
                            return `<h2><a href="${THIS.DOM.table.getAttribute( 'data-url' )}?pn=${(row['Part number'])}">${data}</a></h2>`;
                        } else {
                            return `<a href="${THIS.DOM.table.getAttribute( 'data-url' )}?pn=${(row['Part number'])}">${data}</a>`;
                        }
                    },
                }
            ],
            initComplete: ( settings, json ) => {
                let api = $.fn.dataTable.Api( this.DOM.table )
                // Create header selectes
                this._selects( api )
                // Add listener to search
                //this._listeners( api )
                // Search
                //this._search( api )
                // Hide empty cols
                this._cols( api )
                api.columns.adjust().draw()
                // Loaded
                THIS.DOM.section.style.display = 'block'
                _.removeClass( this.DOM.loader, 'is--active' )
            }
        })
    }
    _selects( api ) {
        let THIS = this
        

        // Filter all columns
        api
        .columns()
        .every(function ( key, col ) {
            var column = api.column(key);
            var select = $(`<select data-key="${$(column.header() ).text()}"></select>`)
            var key = $( column.header() ).text()
                select.append('<option value="">All</option>')
                .appendTo($(column.header()))
                .on('change', function () {
                    THIS._filter()
                });
            column
                .data()
                .unique()
                .sort()
                .each(function (d, j) {
                    let value = d
                    let counter = THIS.results.filter( e => e[key] === d ).length
                    if ( d != '' ) {
                        select.append('<option value="' + d + '">' + d + ' (' + counter + ')</option>');
                    }
                });
        })

        for (const property in this.tableTypeObj) {
            if ( property != 'Product line' && property != 'Type' && property != 'Product' ) {
                const sel = _.select( `table select[data-key="${property}"]` )
                const option = _.select( `table select[data-key="${property}"] option[value="${this.tableTypeObj[property]}"]` )
                option ? sel.value = this.tableTypeObj[property] : null
            }
        }

        
    }

    _search( api ) {
        if ( this.DOM.search.value != '' ) {
            api.search( this.DOM.search.value ).draw()
            this._cols()
        }
    }

    _filter() {
        console.log('Is filerting')
        let selectDOM = event.target,
            selectKey = selectDOM.getAttribute( 'data-key' ),
            selectValue = selectDOM.value
        
        selectValue != '' ? this.tableTypeObj[ selectKey ] = selectValue : delete this.tableTypeObj[ selectKey ]

        this.selected = selectKey
        this.selectedValue = selectValue
        
        this.dttbl.destroy()
        $( 'table select' ).remove()
        

        this._dataInitFilter()
        this._datatable()
    }

    _cols( api ) {
        this.results.filter( e => e['Product'] != '' ).length == 0 ? api.column( 0 ).visible( false ) : null
        this.results.filter( e => e['Product line'] != '' ).length == 0 ? api.column( 1 ).visible( false ) : null
        this.results.filter( e => e['Type'] != '' ).length == 0 ? api.column( 2 ).visible( false ) : null
        this.results.filter( e => e['Part number'] != '' ).length == 0 ? api.column( 3 ).visible( false ) : null
        this.results.filter( e => e['Family'] != '' ).length == 0 ? api.column( 4 ).visible( false ) : null
        this.results.filter( e => e['IF(AV) (A)'] != '' ).length == 0 ? api.column( 5 ).visible( false ) : null
        this.results.filter( e => e['VRRM (V)'] != '' ).length == 0 ? api.column( 6 ).visible( false ) : null
        this.results.filter( e => e['TRR (ns)'] != '' ).length == 0 ? api.column( 7 ).visible( false ) : null
        this.results.filter( e => e['VF (V)'] != '' ).length == 0 ? api.column( 8 ).visible( false ) : null
        this.results.filter( e => e['PZ (W)'] != '' ).length == 0 ? api.column( 9 ).visible( false ) : null
        this.results.filter( e => e['PPP (W)'] != '' ).length == 0 ? api.column( 10 ).visible( false ) : null
        this.results.filter( e => e['VZ (V)'] != '' ).length == 0 ? api.column( 11 ).visible( false ) : null
        this.results.filter( e => e['VCL (V)'] != '' ).length == 0 ? api.column( 12 ).visible( false ) : null
        this.results.filter( e => e['IPP (A)'] != '' ).length == 0 ? api.column( 13 ).visible( false ) : null
        this.results.filter( e => e['Direc'] != '' ).length == 0 ? api.column( 14 ).visible( false ) : null
        this.results.filter( e => e['IFSM (A)'] != '' ).length == 0 ? api.column( 15 ).visible( false ) : null
        this.results.filter( e => e['Outline'] != '' ).length == 0 ? api.column( 16 ).visible( false ) : null
    }
}

const BUSINESS_DIODES = new BusinessDiodesClass()
export default BUSINESS_DIODES